import React, { useContext, useRef, useEffect, useCallback } from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import mainMenu from 'src/js/modules/main-menu';
import UserInputContext from '../../common/components/user-input-context';
import getVisibilityStatus from '../selectors/get-visibility-status';

function Nav({ children = null }) {
  const userInputContext = useContext(UserInputContext);
  const isOpen = useSelector(getVisibilityStatus);
  const navElement = useRef(null);
  const overlayClasses = classNames('ws-nav-overlay', {
    'ws-nav-overlay--active': isOpen,
  });

  const close = useCallback(() => mainMenu.operations.hide(), []);

  useEffect(() => {
    const { subscribe } = userInputContext;

    const onWindowClick = (event) => {
      const { current } = navElement || {};

      if (current && event.target !== current && !current.contains(event.target) && isOpen) {
        close();
      }
    };

    const onKeyDown = (event) => {
      const isEscPressed = event.key && (event.key === 'Esc' || event.key === 'Escape');

      if (isOpen && isEscPressed) {
        close();
      }
    };

    const onClickSubscription = subscribe('click', onWindowClick);
    const onKeyDownSubscription = subscribe('keydown', onKeyDown);

    return () => {
      onClickSubscription.unsubscribe();
      onKeyDownSubscription.unsubscribe();
    };
  }, [userInputContext, isOpen, close]);

  return (
    <div id="nav-menu" className="ws-nav-container">
      <div className="ws-nav" ref={navElement}>
        {children}
      </div>
      <div className={overlayClasses} />
    </div>
  );
}

Nav.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
};

export default Nav;
